import {NoteTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class NoteTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in NoteTypeCd ) {
      this._values.push(NoteTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): NoteTypeCd {

    for ( const obj in NoteTypeCd ) {
      if (NoteTypeCd[obj] === value){
        return NoteTypeCd[obj] as NoteTypeCd;
      }
    }
  }
}

const NoteTypeCdHelper = new NoteTypeCdHelperEnumHelperClass();
export default NoteTypeCdHelper;
